
import React, { createContext, useState, useContext, useEffect } from 'react';
import { MyContext } from './ProviderContext';

export const Team = () => {

    const { menuComponent, setMenuComponent } = useContext(MyContext);

    useEffect(() => {
        setMenuComponent({ home: '', about: '', services: '', team: 'active', contact: '', project: '' });
    }, [])

    return (

        <>
            <div className="page-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>Our Team</h2>
                        </div>
                        <div className="col-12">
                            <a href="/">Home</a>
                            <a href="">Our Team</a>
                        </div>
                    </div>
                </div>
            </div>


            <div className="service">
                <div className="container">
                    <div className="section-header text-center">
                        <p>Our Team</p>
                        <h2>Meet Our Reliable Workforce</h2>
                    </div>
                    <div className="row" >

                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/team/emeka.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            Emeka has a degree in Electrical Electronics Engineering and has been in the Oil and Gas Industry for over 15 years in top EPC organizations. He has overseen the operations of Frantino with zest and has been instrumental in the successful bidding, administration and completion of over 15 projects with Frantino.

                                        </p>
                                    </div>
                                </div>
                                <div className="team-text">
                                    <h2>Emeka James Ube</h2>
                                    <i>PMP</i>
                                    <p>General Manager</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/team/ikeh.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            Mr. Ikeh has over 12 years experience in EPC Project Management. He bags a degree in Mechanical Engineering and a Post Graduate Diploma in Project Management. He is also PMP Certified by PMI and is a certified mechanical engineer with COREN and Nigerian Institute of Mechanical Engineers.

                                        </p>
                                    </div>
                                </div>
                                <div className="team-text">
                                    <h2>Ikeh Darlington</h2>
                                    <i>MNIMechE</i>
                                    <p>Project Manager</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/team/fidelis.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            Mr. Fidelis is a registered engineer with the Nigerian Society of Engineers, NSE and is COREN Certified and has CSWIP, ANST, ASME & Six Sigma(yellow belt, green belt) certification in Quality Management. He has over 16 years experience in the industry and oversees our engineering and construction team.

                                        </p>
                                    </div>
                                </div>
                                <div className="team-text">
                                    <h2>Fidelis Owan Odong</h2>
                                    <i>MNSE, COREN</i>
                                    <p>Engineering Manager</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/team/favour.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            Favour has a degree in Gas Engineering and has been in the Oil and Gas Industry for over 8 years in top EPC organizations. He has successfully represented in all Frantino projects carried out over the years.

                                        </p>
                                    </div>
                                </div>
                                <div className="team-text">
                                    <h2>Favour Umaroh</h2>
                                    <p>Operations Manager</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/team/okorie.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            Engr. Okorie Imaga is a registered engineer with the Nigeria Society of Engineers, NSE and is COREN Certified. He has over 17 years experience in EPC Project. He oversees all the construction activities in FMSL

                                        </p>
                                    </div>
                                </div>
                                <div className="team-text">
                                    <h2>Okorie Imaga</h2>
                                    <i>MNSE, COREN</i>
                                    <p>Construction Manager</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/team/chidozie.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            Engr. Chidozie is a registered engineer with the Nigeria Society of Engineers, NSE and is COREN certified and has over 8 years experience in the industry and oversees our engineering and construction team.

                                        </p>
                                    </div>
                                </div>
                                <div className="team-text">
                                    <h2>Chidozie Urama</h2>
                                    <i>MNSE, COREN</i>
                                    <p>Civil / Structural Engineer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}